import React from 'react'
import { useState, useEffect } from 'react'
import { Routes, Route, NavLink, useNavigate, useLocation, useParams } from 'react-router-dom'
import ProviderTracker from '../pages/ProviderTracker';

import { useDispatch, useSelector } from 'react-redux';
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'
import CounselorTracker from '../pages/CounselorTracker';
import NurseTracker from '../pages/NurseTracker';



const PatientTrackerTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [claimCountData, setclaimCountData] = useState('');

  const [patientId, setPatientId] = useState(null);
  const [secondaryInsData, setSecondaryInsData] = useState([]);


  const { id } = useParams();

  console.log('NavigationPatientId:>>>>>>', id);
  console.log('NavigationPatientId:>>>>>>', patientId);


  const dispatch = useDispatch();


  const userData = useSelector((state) => state.user.user);
  console.log('userData:', userData);

  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const pendingClaim = useSelector((state) => state.user.filterTableDetails);
  const rejectedCount = useSelector((state) => state.user.rejectedClaim);

  const sAuthToken = useSelector((state) => state.user.token);

  // const claimId = useSelector((state) => state.user.claimId);


  useEffect(() => {
    const storedPatientId = localStorage.getItem("PatientId");
    setPatientId(storedPatientId);
  }, []);







  useEffect(() => {
    const currentTab = location.pathname.split("/").pop();
    setActiveTab(currentTab);
   
    if (!currentTab || location.pathname === "/BillerPatientTracker") {
      navigate("/BillerPatientTracker/Provider", { replace: true });
    }
  }, [location, navigate]);



  const handleTabClick = (tab) => {
    setActiveTab(tab);
    navigate(`/BillerPatientTracker/${tab}`);
  };



  return (
    <>


      <div className='topnavmenu text-center'>
        <label style={{ fontSize: '1.2rem', marginTop: '10px', textAlign: 'center', textTransform: 'uppercase' }}> Patient Tracker</label>
      </div>


      <ul className="nav nav-pills mt-1 nav-style" id="pills-tab" role="tablist" >



        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'Provider' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-profile"
            aria-selected={activeTab === 'Provider'}
            onClick={() => handleTabClick('Provider')}
          >
            Provider
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'counselor' ? 'active-tab' : ''}`}

            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'counselor'}
            onClick={() => handleTabClick('counselor')}
          >
            <label style={{ backgroundColor: secondaryInsData.length > 0 ? 'yellow' : '', color: secondaryInsData.length > 0 ? 'black' : '', }}>Counselor</label>
          </a>
        </li>

        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'nurse' ? 'active-tab' : ''}`}

            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'nurse'}
            onClick={() => handleTabClick('nurse')}
          >
            <label style={{ backgroundColor: secondaryInsData.length > 0 ? 'yellow' : '', color: secondaryInsData.length > 0 ? 'black' : '', }}>Nurse</label>
          </a>
        </li>


      </ul>


      <div className="tab-content" id="pills-tabContent" >
        <Routes>

          <Route path="Provider" element={<ProviderTracker />} />
          <Route path="counselor" element={<CounselorTracker />} />
          <Route path="nurse" element={<NurseTracker />} />

        </Routes>
      </div>
    </>
  )
}

export default PatientTrackerTabs
